import { CARCS, getBaseCarcCode, NATERA_TAGS, RARCS } from '~/entities/carc-rarc'

export type CodeKind = 'CARC' | 'RARC' | 'Natera tag'

/** What a code means, from Opti's code lists; CARCs match on their number, whatever the prefix. */
export function describeCode(code: string): { kind: CodeKind | null; description: string | null } {
  const tag = NATERA_TAGS.find((item) => item.code === code)
  if (tag) return { kind: 'Natera tag', description: tag.description || tag.label }
  const rarc = RARCS.find((item) => item.code === code)
  if (rarc) return { kind: 'RARC', description: rarc.description || rarc.label }
  const base = getBaseCarcCode(code)
  const carc = CARCS.find((item) => getBaseCarcCode(item.code) === base)
  if (carc) return { kind: 'CARC', description: carc.description || carc.label }
  return { kind: null, description: null }
}
